"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lib_1 = require("@brandfree-front/lib");
const file_saver_1 = require("file-saver");
const GaButton_1 = __importDefault(require("../util/GaButton"));
const StoresUtil_1 = require("../util/StoresUtil");
let ShowRequests = class ShowRequests extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState((prevState) => ({
                    isToggleOn: !prevState.isToggleOn
                }));
            }
        });
        Object.defineProperty(this, "renderRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => {
                const { translate } = this.translateStore;
                return (react_1.default.createElement(lib_1.Grid, { key: request.id },
                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs-5'] }, this.formatDate(request.createdAt)),
                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs-4'] }, request.status !== 'CLOSED' ? translate('gdpr.showRequests.status.open') : translate('gdpr.showRequests.status.closed')),
                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs-3'] }, request.status === 'CLOSED' && request.attachments && !this.ssoStore.isDealer && (react_1.default.createElement(GaButton_1.default, { id: "download-file", ariaLabel: "download", link: true, iconRight: "#file", onClick: () => this.downloadFile(request), text: "" })))));
            }
        });
        Object.defineProperty(this, "hasActiveRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => {
                return request.status === 'OPEN' || request.status === 'ERROR' || (request.status === 'CLOSED' && request.attachments);
            }
        });
        Object.defineProperty(this, "hasInactiveRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => {
                return request.status === 'CLOSED' && !request.attachments;
            }
        });
        Object.defineProperty(this, "renderRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (state) => {
                const list = this.state.Requests.filter((request) => {
                    switch (state) {
                        case 'active':
                            return this.hasActiveRequests(request);
                        case 'inactive':
                            return this.hasInactiveRequests(request);
                        default:
                            return false;
                    }
                });
                return list.map((request) => {
                    return this.renderRequest(request);
                });
            }
        });
        Object.defineProperty(this, "noActiveRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.translateStore;
                return (react_1.default.createElement(lib_1.Grid, null,
                    react_1.default.createElement(lib_1.GridColumn, null, translate('gdpr.showRequests.noActiveRequests'))));
            }
        });
        Object.defineProperty(this, "downloadFile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => {
                this.consentStore.getAttachments(request.id).then((response) => {
                    (0, file_saver_1.saveAs)(response.data, `${request.id}.zip`);
                });
            }
        });
        Object.defineProperty(this, "formatDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (s) => {
                const date = new Date(s).toLocaleDateString('en-GB', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                return date.replace(new RegExp('/', 'g'), '.');
            }
        });
        this.state = {
            isToggleOn: false,
            Requests: []
        };
    }
    async componentDidMount() {
        if (this.ssoStore.isLoggedIn && !this.ssoStore.isDealer) {
            const Requests = await this.consentStore.getRequests(this.props.requestType);
            this.setState({ Requests });
        }
    }
    render() {
        const { translate } = this.translateStore;
        if (this.ssoStore.isDealer) {
            return react_1.default.createElement(lib_1.Notice, { type: "employee" }, translate('gdpr.showRequests.employeeNotice'));
        }
        if (this.ssoStore.loaded && this.ssoStore.isLoggedIn && this.state.Requests.length > 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                        react_1.default.createElement("h4", null, translate('gdpr.showRequests.title')),
                        react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" }),
                        react_1.default.createElement(lib_1.Grid, null,
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-5'] },
                                react_1.default.createElement("strong", null, translate('gpdr.showRequests.requestDate'))),
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-4'] },
                                react_1.default.createElement("strong", null, translate('gpdr.showRequests.state'))),
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-3'] },
                                react_1.default.createElement("strong", null, translate('gpdr.showRequests.answer')))),
                        this.renderRequests('active').length > 0 ? this.renderRequests('active') : this.noActiveRequests(),
                        this.state.isToggleOn ? this.renderRequests('inactive') : '',
                        this.renderRequests('inactive').length > 0 && (react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" }),
                                react_1.default.createElement(GaButton_1.default, { id: "show-request-show-all", text: translate('gdpr.showRequests.showAll'), onClick: this.handleClick })))),
                        react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" }),
                        react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                                react_1.default.createElement(lib_1.Notice, { size: "small" }, translate('gdpr.showRequests.filesExpire')))))),
                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" })));
        }
        return null;
    }
};
ShowRequests = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ShowRequests);
exports.default = ShowRequests;
